"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withForm;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactHookForm = require("react-hook-form");

var _reactRouter = require("react-router");

var _yup = require("@hookform/resolvers/yup");

var _devtools = require("@hookform/devtools");

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _molecules = require("../components/molecules");

var _atoms = require("../components/atoms");

var _Icons = require("../components/atoms/Icons");

var _excluded = ["onCancel", "responseStatus", "successIcon", "errorIcon", "closeResponseDialog", "successPath", "onSuccessResponse", "onErrorResponse", "reactHookFormProps", "left", "right", "leftClassName", "rightClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function withForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      schema = _ref.schema,
      _ref$defaultValues = _ref.defaultValues,
      defaultValues = _ref$defaultValues === void 0 ? {} : _ref$defaultValues,
      _ref$submitForm = _ref.submitForm,
      submitForm = _ref$submitForm === void 0 ? _noop2.default : _ref$submitForm,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'onChange' : _ref$mode,
      _ref$showButtons = _ref.showButtons,
      showButtons = _ref$showButtons === void 0 ? true : _ref$showButtons,
      _ref$isActionSubmit = _ref.isActionSubmit,
      isActionSubmit = _ref$isActionSubmit === void 0 ? true : _ref$isActionSubmit,
      _ref$withConfirmation = _ref.withConfirmationMessage,
      withConfirmationMessage = _ref$withConfirmation === void 0 ? true : _ref$withConfirmation,
      _ref$confirmation = _ref.confirmation,
      confirmation = _ref$confirmation === void 0 ? {} : _ref$confirmation,
      _ref$response = _ref.response,
      response = _ref$response === void 0 ? {} : _ref$response,
      formatter = _ref.formatter,
      transformer = _ref.transformer,
      _ref$cancelLabel = _ref.cancelLabel,
      cancelLabel = _ref$cancelLabel === void 0 ? 'Cancelar' : _ref$cancelLabel,
      _ref$submitLabel = _ref.submitLabel,
      submitLabel = _ref$submitLabel === void 0 ? 'Guardar' : _ref$submitLabel;

  return function (Component) {
    function FormWrapperChildren(_ref2) {
      var _ref2$onCancel = _ref2.onCancel,
          onCancel = _ref2$onCancel === void 0 ? _noop2.default : _ref2$onCancel,
          _ref2$responseStatus = _ref2.responseStatus,
          responseStatus = _ref2$responseStatus === void 0 ? {} : _ref2$responseStatus,
          _ref2$successIcon = _ref2.successIcon,
          successIcon = _ref2$successIcon === void 0 ? /*#__PURE__*/_react.default.createElement(_Icons.IcoCarOk, null) : _ref2$successIcon,
          _ref2$errorIcon = _ref2.errorIcon,
          errorIcon = _ref2$errorIcon === void 0 ? /*#__PURE__*/_react.default.createElement(_Icons.IcoCarError, null) : _ref2$errorIcon,
          closeResponseDialog = _ref2.closeResponseDialog,
          _ref2$successPath = _ref2.successPath,
          successPath = _ref2$successPath === void 0 ? '' : _ref2$successPath,
          onSuccessResponse = _ref2.onSuccessResponse,
          _ref2$onErrorResponse = _ref2.onErrorResponse,
          onErrorResponse = _ref2$onErrorResponse === void 0 ? _noop2.default : _ref2$onErrorResponse,
          _ref2$reactHookFormPr = _ref2.reactHookFormProps,
          reactHookFormProps = _ref2$reactHookFormPr === void 0 ? {} : _ref2$reactHookFormPr,
          _ref2$left = _ref2.left,
          left = _ref2$left === void 0 ? /*#__PURE__*/_react.default.createElement(Left, null) : _ref2$left,
          _ref2$right = _ref2.right,
          right = _ref2$right === void 0 ? null : _ref2$right,
          _ref2$leftClassName = _ref2.leftClassName,
          leftClassName = _ref2$leftClassName === void 0 ? 'w-2/3 flex items-center text-sm' : _ref2$leftClassName,
          _ref2$rightClassName = _ref2.rightClassName,
          rightClassName = _ref2$rightClassName === void 0 ? 'w-1/3 grid grid-cols-2 gap-x-4' : _ref2$rightClassName,
          props = _objectWithoutProperties(_ref2, _excluded);

      var _useState = (0, _react.useState)(false),
          _useState2 = _slicedToArray(_useState, 2),
          openConfirmation = _useState2[0],
          setOpenConfirmation = _useState2[1];

      var _useState3 = (0, _react.useState)(defaultValues),
          _useState4 = _slicedToArray(_useState3, 2),
          currentDefaultValues = _useState4[0],
          setCurrentDefaultValues = _useState4[1];

      var dispatch = (0, _reactRedux.useDispatch)();
      var history = (0, _reactRouter.useHistory)();
      var form = (0, _reactHookForm.useForm)(_objectSpread({
        resolver: (0, _yup.yupResolver)(schema),
        mode: mode,
        defaultValues: currentDefaultValues
      }, reactHookFormProps));
      var handleSubmit = form.handleSubmit,
          control = form.control,
          setValue = form.setValue;
      var handleSubmitForm = (0, _react.useCallback)(function () {
        var values = form.getValues();

        if (formatter) {
          values = formatter(values);
        }

        if (isActionSubmit) {
          dispatch(submitForm(values));
        } else {
          submitForm(values);
        }

        setOpenConfirmation(false);
      }, [dispatch, form, isActionSubmit]);
      var onSubmit = (0, _react.useCallback)(function () {
        if (withConfirmationMessage && !openConfirmation) {
          setOpenConfirmation(true);
        } else {
          handleSubmitForm();
        }
      }, [withConfirmationMessage, openConfirmation, handleSubmitForm]);
      var handleCancel = (0, _react.useCallback)(function () {
        onCancel(form);
      }, [onCancel, form]);
      var handleConfirm = (0, _react.useCallback)(function () {
        handleSubmitForm();
      }, [handleSubmitForm]);
      var handleCancelConfirm = (0, _react.useCallback)(function () {
        setOpenConfirmation(false);
      }, []);
      var handleSuccessResponse = (0, _react.useCallback)(function () {
        if (successPath === 'refresh') {
          window.location.reload();
          return;
        }

        if (onSuccessResponse) {
          onSuccessResponse();
          return;
        }

        history.push(successPath);
      }, [history, successPath, onSuccessResponse]);
      var handleErrorResponse = (0, _react.useCallback)(function () {
        onErrorResponse();
      }, [onErrorResponse]);
      var handleResponseConfirm = (0, _react.useCallback)(function () {
        if (responseStatus.success) {
          handleSuccessResponse();
        } else {
          handleErrorResponse();
        }
      }, [responseStatus, handleErrorResponse, handleSuccessResponse]);
      var hydrateValues = (0, _react.useCallback)(function (newValues) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true
        };
        var listOfValues = Object.entries(transformer ? transformer(newValues) : newValues);
        listOfValues.forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              value = _ref4[1];

          setValue(key, value, options);
          setCurrentDefaultValues(function (prevState) {
            prevState[key] = value;
            return prevState;
          });
        });
      }, [setValue]);
      var actionLabel = (0, _react.useMemo)(function () {
        if (responseStatus.success) {
          return response.successLabel || 'Aceptar';
        }

        return response.errorLabel || 'Reintentar';
      }, [responseStatus, response]);
      var responseTitle = (0, _react.useMemo)(function () {
        return responseStatus.success ? response.successTitle : response.errorTitle;
      }, [responseStatus, response]);
      var responseMessage = (0, _react.useMemo)(function () {
        return responseStatus.success ? response.successMessage : response.errorMessage;
      }, [responseStatus, response]);

      var renderRight = right || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
        outline: true,
        onClick: handleCancel
      }, cancelLabel), /*#__PURE__*/_react.default.createElement(_atoms.Button, {
        type: "submit",
        onClick: handleSubmit(onSubmit)
      }, submitLabel));

      return /*#__PURE__*/_react.default.createElement(_reactHookForm.FormProvider, _extends({}, form, {
        defaultValues: currentDefaultValues,
        hydrateValues: hydrateValues,
        onSubmit: handleSubmit(onSubmit)
      }), /*#__PURE__*/_react.default.createElement(_molecules.ActionModal, {
        open: openConfirmation,
        icon: /*#__PURE__*/_react.default.createElement(_Icons.StatusWarning, null),
        title: confirmation.title,
        message: confirmation.message,
        onAction: handleConfirm,
        actionLabel: confirmation.actionLabel || 'Aceptar',
        onClose: handleCancelConfirm,
        closeLabel: confirmation.closeLabel
      }), /*#__PURE__*/_react.default.createElement(_molecules.ActionModal, {
        open: responseStatus.open,
        icon: responseStatus.success ? successIcon : errorIcon,
        onClose: closeResponseDialog,
        onAction: handleResponseConfirm,
        title: responseTitle,
        actionLabel: actionLabel,
        message: responseMessage,
        modalType: responseStatus.modalType || (responseStatus.success ? 'confirmation' : 'action'),
        code: responseStatus.errorCode,
        closeButton: true
      }), /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
        form: form,
        hydrateValues: hydrateValues,
        onSubmit: handleSubmit(onSubmit),
        defaultValues: currentDefaultValues
      })), showButtons && /*#__PURE__*/_react.default.createElement("div", {
        className: "flex justify-between mt-8 mb-4 pt-8"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: leftClassName
      }, left), /*#__PURE__*/_react.default.createElement("div", {
        className: rightClassName
      }, renderRight)), /*#__PURE__*/_react.default.createElement(_devtools.DevTool, {
        control: control
      }));
    }

    FormWrapperChildren.propTypes = {
      onCancel: _propTypes.default.func,
      withConfirmationMessage: _propTypes.default.bool,
      successIcon: _propTypes.default.node,
      errorIcon: _propTypes.default.node,
      closeResponseDialog: _propTypes.default.func,
      responseStatus: _propTypes.default.shape({
        open: _propTypes.default.bool,
        success: _propTypes.default.bool,
        errorCode: _propTypes.default.string,
        errorMessage: _propTypes.default.string
      }),
      successPath: _propTypes.default.string,
      onSuccessResponse: _propTypes.default.func,
      onErrorResponse: _propTypes.default.func,
      reactHookFormProps: _propTypes.default.object,
      right: _propTypes.default.node,
      left: _propTypes.default.node,
      leftClassName: _propTypes.default.string,
      rightClassName: _propTypes.default.string
    };
    return FormWrapperChildren;
  };
}

function Left() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Icons.Comment, {
    className: "mr-4",
    width: "1.5rem",
    height: "1.5rem"
  }), "*Campos obligatorios");
}